import Head from "next/head";
export default function Home() {
  return (
    <>
      <Head>
        <title>The Food Exchange</title>
        <meta name="description" content="Generated by The Food Exchange" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href="/images/Logo.svg" />
      </Head>
    </>
  );
}
